<template>
  <div class="Pre-order-details">
    <section class="main_content">
      <OrderDetails :dataValues="preOrderDetails" />
      <AddressDetail
        :userAddressData="userAddressDto"
        @selectAddressId="getAddressId"
        @nearPayEnable="getNearPayEnable"
        @codEnable="getCODEnable"
      />
      <div class="limited_offer" v-if="preOrderDetails.dealDisplayMessage">
        <Timer :timing="getLiveTime(preOrderDetails.dealEndTimeMillis)" />
        <span class="msg_offer_time">{{preOrderDetails.dealDisplayMessage}}</span>
      </div>
      <PriceDetail :dataValues="preOrderDetails" />
      <div class="card-payment">
        <label class="container" @click="changeDiscount('ZYK_PAY')" :v-model="payments.method">
          <input type="radio" name="radio" />
          <span class="checkmark" :class="{'active' : isPaymentEnable == 'ZYK_PAY'}"></span>
          <span class="card-img">
            <img src="../../assets/images/icons/paytm.jpg" alt style="width: 26px;height: 14px;" />
          </span>
          <span style="display:block">
            {{$t('paytmPayment')}}
            <span
              v-if="preOrderDetails.onlineDiscount>0 && ['ZYK_PAY_RAZORPAY','ZYK_PAY'].includes(isPaymentEnable)"
              style="display: block;color: green;font-size: 0.875em;font-weight: 500;"
            >{{$t('extraDiscountOnOrder',{cost:preOrderDetails.onlineDiscount})}}</span>
          </span>
        </label>
        <label
          class="container"
          @click="changeDiscount('ZYK_PAY_RAZORPAY')"
          :v-model="payments.method"
        >
          <input type="radio" name="radio" />
          <span class="checkmark" :class="{'active' : isPaymentEnable == 'ZYK_PAY_RAZORPAY'}"></span>
          <span class="card-img">
            <img src="../../assets/images/icons/credit-card.svg" alt />
          </span>
          <span style="display:block">
            {{$t('debitOrNet')}}
            <span
              v-if="preOrderDetails.onlineDiscount>0 && ['ZYK_PAY_RAZORPAY','ZYK_PAY'].includes(isPaymentEnable)"
              style="display: block;color: green;font-size: 0.875em;font-weight: 500;"
            >{{$t('extraDiscountOnOrder',{cost:preOrderDetails.onlineDiscount})}}</span>
          </span>
        </label>
        <div style="position:relative;">
          <label
            class="container"
            @click="changeDiscount('COD')"
            :v-model="payments.method"
            v-if="codEnabled"
          >
            <input type="radio" name="radio" />
            <span class="checkmark" :class="{'active' : isPaymentEnable == 'COD'}"></span>
            <span class="card-img">
              <img src="../../assets/images/icons/cod.svg" alt />
            </span>
            {{$t('cashOnDelivery')}}
          </label>
          <label
            class="container codDisableReason"
            @click="isCODEnabled = !isCODEnabled"
            :v-model="payments.method"
            v-else
          >
            <span class="card-img">
              <img src="../../assets/images/icons/cod.svg" alt />
            </span>
            {{$t('notAvailableCod')}}
            <i class="material-icons">info</i>
          </label>
        </div>
        <label
          class="container"
          @click="changeDiscount('NEAR_PAY')"
          :v-model="payments.method"
          v-if="nearPayEnabled"
        >
          <input type="radio" name="radio" />
          <span class="checkmark" :class="{'active' : isPaymentEnable == 'NEAR_PAY'}"></span>
          <span class="card-img">
            <img src="../../assets/images/paynearby.png" alt />
          </span>
          {{$t('nearPePayment')}}
        </label>
        <div
          v-if="['COD', 'CALL'].includes(payments.method) && extraDisMsg && extraDisMsg.length>0"
          class="select_cod_msg"
        >{{extraDisMsg}}</div>
      </div>
      <div class="order_button" v-if="showOrderButton">
        <button type="button" class="large_green_btn" @click="createNewOrder()">{{$t('doOrder')}}</button>
      </div>
      <div class="customModal" v-if="CODModal">
        <div class="modal_dialog Cod">
          <div class="modal_content">
            <div class="modal_header">
              <h3>{{$t('chooseCOD')}}</h3>
              <i class="material-icons close_icon" @click="CODModal = !CODModal">close</i>
            </div>
            <div class="modal_body padding0">
              <p>{{$t('CODMsg' , {preorderTotalAmount: preOrderDetails.totalPaidAmount})}}</p>
            </div>
            <div class="modal_footer">
              <button type="button" class="order_btn" @click="confirmCodModal()">{{$t('doOrder')}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="customModal" v-if="isCODEnabled">
        <div class="modal_dialog Cod">
          <div class="modal_content">
            <div class="modal_body padding0">
              <p>{{$t('msgForNotAvailCOD')}}</p>
            </div>
            <div class="modal_footer">
              <button
                type="button"
                class="order_btn"
                @click="isCODEnabled = !isCODEnabled"
              >{{$t('okText')}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
    </section>
    <CustomToaster :dataValue="toasterData" v-if="isPaymentMethod" />
  </div>
</template>

<script>
import "../../assets/css/pre-order-detail.scss";
import constant from "../../utils/constant";
import { bus } from "../../main";
import CustomToaster from "../Common/CustomToaster";
import OrderDetails from "./OrderDetails";
import AddressDetail from "./AddressDetail";
import PriceDetail from "./PriceDetail";
import Timer from "../../components/Common/TimeCount";
import { mapGetters, mapState } from "vuex";
export default {
  name: "PreOrderDetails",
  components: {
    CustomToaster,
    OrderDetails,
    AddressDetail,
    PriceDetail,
    Timer
  },
  data() {
    return {
      toasterData: {},
      CODModal: false,
      confirmCod: false,
      isPaymentMethod: false,
      isCODEnabled: false,
      xauthid: "",
      showCheck: true,
      orderDetails: {},
      preOrderDetails: {},
      addressDTO: {},
      interval: null,
      subOrderDto: [],
      orderStatus: {},
      loading: false,
      codEnabled: false,
      nearPayEnabled: false,
      codDisMsg: "",
      extraDisMsg: "",
      showOrderButton: true,
      payments: {
        method: ""
      },
      userAddressDto: [],
      userAddressID: "",
      verifiedXAuthId: [
        "1ee2e5e34c2886bf91b82adfcea38b4c",
        "1c9ac0159c94d8d0cbedc973445af2da"
      ],     
      ApiType: "createOrderByPreorderAgain",
      isPaymentEnable: false
    };
  },
  watch: {
    codDisMsg() {
      this.codDisMsg = this.codDisMsg;
    }
  },
  methods: {
    getLiveTime(value) {
      let milliseconds = Number(value) / 1000;
      return milliseconds;
    },
    timerStop(obj) {
      if (this.liveData.length > 0) {
        this.liveData[obj.index].status = false;
      }
    },
    orderOnline() {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/paymentWaiting/" + this.$route.params.orderId);
    },
    verifyXAuthId() {
      verifiedXAuthId.forEach(function(element) {
        if (this.$cookie.get("X-Auth-Id") == element) {
          this.showCheck == true;
        } else {
          this.showCheck == false;
        }
      });
    },
    changeDiscount(method) {
      this.payments.method = method;
      if (this.payments.method) {
        this.isPaymentEnable = method;
      } else {
        this.isPaymentEnable = false;
      }
      if (method != "CALL") {
        var totalPaid = parseFloat(this.preOrderDetails.totalPaidAmount);
        if (
          this.preOrderDetails.onlineDiscount != null &&
          parseFloat(this.preOrderDetails.onlineDiscount) > 0
        ) {
          if (
            this.payments.method === "ZYK_PAY" ||
            this.payments.method === "ZYK_PAY_RAZORPAY" ||
            this.payments.method === "PAY91"
          ) {
            if (
              totalPaid > parseFloat(this.preOrderDetails.onlineDiscount) &&
              this.preOrderDetails.online == 0
            ) {
              this.preOrderDetails.online = parseFloat(
                this.preOrderDetails.onlineDiscount
              );
              this.extraDisMsg =
                "बधाई हो! आप को " +
                this.preOrderDetails.onlineDiscount +
                " Rs की अतिरिक्त छूट मिल रही है इस आर्डर पर!";
              this.preOrderDetails.totalPaidAmount = Math.round(
                totalPaid - parseFloat(this.preOrderDetails.onlineDiscount)
              );
            }
          } else {
            if (Math.round(this.preOrderDetails.onlineDiscount) > 0) {
              this.extraDisMsg =
                this.preOrderDetails.onlineDiscount +
                " Rs अतरिक्त छूट COD पेमेंट सेलेक्ट करने की वजह से हटा दी गई है!";
              this.preOrderDetails.totalPaidAmount = Math.round(
                totalPaid + parseFloat(this.preOrderDetails.onlineDiscount)
              );
              this.preOrderDetails.online = 0;
            }
          }
        }
      }
    },
    getAddressForUser() {
      this.$store
        .dispatch({
          type: "getAddressesForUser"
        })
        .then(data => {
          if (data.data && data.data.length > 0) {
            this.userAddressDto = data.data;
            this.userAddressID = this.userAddressDto[0].addressId;
          }
        })
        .catch(err => {
          this.loading = false;
          this.emitToaster("Failure");
        });
    },
    getAddressId(value) {
      this.userAddressID = value;
    },
    getNearPayEnable(value) {
      this.nearPayEnabled = value;
    },
    getCODEnable(value) {
      this.codEnabled = value;
    },
    getPreordersById() {
      this.loading = true;
      var _this = this;
      this.$store
        .dispatch({
          type: "getPreOrderById",
          payload: this.$route.params.preOrderId
        })
        .then(data => {
          this.loading = false;
          this.preOrderDetails = data.data;
          this.$store.commit("savePreOrderDetail", {
            availablePreOrderData: this.preOrderDetails
          });
          this.codEnabled = this.preOrderDetails.codEnabled;
          this.nearPayEnabled = this.preOrderDetails.nearPayEnabled;
          if (
            this.preOrderDetails.onlineDiscount != null &&
            parseFloat(this.preOrderDetails.onlineDiscount) > 0 &&
            totalPaid > parseFloat(this.preOrderDetails.onlineDiscount)
          ) {
            this.extraDisMsg =
              "बधाई हो! आप को " +
              this.preOrderDetails.onlineDiscount +
              "Rs की अतिरिक्त छूट मिल रही है इस आर्डर पर!";
            this.preOrderDetails.online = parseFloat(
              this.preOrderDetails.onlineDiscount
            );
            this.preOrderDetails.totalPaidAmount = Math.round(
              totalPaid - parseFloat(this.preOrderDetails.onlineDiscount)
            );
          } else {
            this.preOrderDetails.online = 0;
          }
        })
        .catch(err => {
          this.loading = false;
          this.emitToaster("Failure");
        });
    },
    emitToaster(status) {
      let obj = {
        status: status,
        color: "black",
        timeoutMs: "5000"
      };
      bus.$emit("apiStatus", obj);
    },
    goToProductDetail(productSrId, type) {
      this.$cookie.delete("type");
      this.$cookie.set("type", type);
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/detail/" + productSrId);
    },
    confirmCodModal() {
      this.loading = true;
      this.confirmCod = true;
      this.showOrderButton = false;
      clevertap.event.push("PRODUCT_BUY_COD", {
        preOrderId: this.preOrderDetailspreOrderId
      });

      const obj = {
        preOrderId: this.preOrderDetails.preOrderId,
        addressDTO: {
          addressId: this.userAddressID
        },
        orderState: "CONFIRMED",
        paymentMethod: this.payments.method,
        orderSourceType: this.$route.query.source || null
      };
      this.CODModal = false;
      this.createOrderApi(obj);
    },

    createNewOrder() {
      if (this.payments.method) {
        if (this.userAddressID) {
          this.showOrderButton = false;
          this.loading = true;
          var orderState = "CONFIRMED";
          if (
            this.payments.method === "ZYK_PAY" ||
            this.payments.method === "PAY91" ||
            this.payments.method === "NEAR_PAY" ||
            this.payments.method === "ZYK_PAY_RAZORPAY"
          ) {
            orderState = "PAYMENT_PENDING";
            clevertap.event.push("PRODUCT_BUY_ONLINE", {
              preOrderId: this.preOrderDetailspreOrderId
            });
          } else {
            this.CODModal = true;
            this.confrimText =
              "आप का आर्डर १०-१५ दिन मैं पहुंच जायेगा ! कॅश ऑन डिलीवरी - सामान पहुंचने पर आप को ₹" +
              this.preOrderDetails.totalPaidAmount +
              " देने होंगे !";
            this.loading = false;
            if (this.CODModal) {
              if (!this.confirmCod) {
                this.showOrderButton = true;
                return false;
              } else {
                this.confirmCodModal();
              }
            } else {
              return;
            }
          }

          const obj = {
            preOrderId: this.preOrderDetails.preOrderId,
            addressDTO: {
              addressId: this.userAddressID
            },
            orderState: orderState,
            paymentMethod: this.payments.method,
            orderSourceType: this.$route.query.source || null
          };
          this.createOrderApi(obj);
        }
      } else {
        this.isPaymentMethod = true;
        this.toasterData = {
          msg: this.$t("pleaseChoosePaymentOption"),
          color: "black"
        };
      }
    },
    createOrderApi(obj) {
      if (this.$cookie.get("version-code") > 58) {
        this.ApiType = "createOrderByPreorderAgain";
      } else {
        this.ApiType = "createOrderByPreorder";
      }

      this.$store
        .dispatch({
          type: this.ApiType,
          payload: obj
        })
        .then(data => {
          this.orderDetails = data.data;
          this.$store.commit("SaveOrderDetails", this.orderDetails);
          if (this.orderDetails.paymentMethod === "ZYK_PAY") {
            var payUrl =
              constant.BASE_URL_ORDERS_PAYMENT + this.orderDetails.orderId;
            window.location.href = payUrl;
            // this.loading = false;
          } else if (this.orderDetails.paymentMethod === "ZYK_PAY_RAZORPAY") {
            var payUrl =
              constant.BASE_URL_ORDERS_PAYMENT + this.orderDetails.orderId;
            window.location.href = payUrl;
          } else if (this.orderDetails.paymentMethod === "NEAR_PAY") {
            // window.location.href = this.orderDetails.storeLink;
            this.$router.onError(err => {
              if (/loading chunk \d* failed./i.test(err.message)) {
                window.location.reload();
              }
            });
            this.$router.push(
              "/nearpay-orderdetails/" + this.orderDetails.orderId
            );
            // this.loading = false;
          } else if (this.orderDetails.paymentMethod === "PAY91") {
            var pay91Url = this.orderDetails.paytmLink;
            this.loading = false;
            try {
              JSBridgePlugin.openInBrowser(pay91Url);
            } catch (err) {
              console.log(err);
              this.emitToaster("Failure");
            }
            this.$router.onError(err => {
              if (/loading chunk \d* failed./i.test(err.message)) {
                window.location.reload();
              }
            });
            this.$router.push("/paymentWaiting/" + this.orderDetails.orderId);
          } else {
            this.$router.onError(err => {
              if (/loading chunk \d* failed./i.test(err.message)) {
                window.location.reload();
              }
            });
            this.$router.push("/orderDetails/" + this.orderDetails.orderId);
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          var _this = this;
          if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            this.loading = false;
            try {
              _JWT.refereshToken = res => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.ApiType = "createOrderByPreorderAgain";
                  _this.createOrderApi(obj);
                } else {
                  this.loading = false;
                  this.showOrderButton = true;
                  this.emitToaster("Something went wrong! Try Again Later");
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          } else {
            this.showOrderButton = true;
            this.loading = false;
            if (err.response.data.message) {
              this.emitToaster(err.response.data.message);
              this.goToProductDetail(
                this.preOrderDetails.saleProductDetailsDTO.saleReferenceID,
                "NORMAL"
              );
            } else {
              this.emitToaster("orderAgain");
            }
          }
        });
    },
  },
  computed: {
    ...mapState(["availablePreOrderData"])
  },
  mounted() {
    if (this.$cookie.get("X-Auth-Id")) {
      this.getAddressForUser();
    }
    if (this.availablePreOrderData) {
      this.preOrderDetails = this.availablePreOrderData;
    } else {
      this.getPreordersById();
    }
  }
};
</script>